import styled from '@emotion/styled';
import React, { ReactNode } from 'react';
import { useMediaQuery } from '../../../../utils/hooks/useMediaQuery';
import { breakpointQueries, breakpoints, spacing } from '../../../../utils/styleguide';
import { Col, Row } from '../12ColGridLayout';

const SizedRow = styled(Row)`
  ${breakpoints.tablet} {
    display: grid;
    padding: ${spacing[8]}px 0;
    ${({ fixedMediaHeight }: { fixedMediaHeight: boolean }) =>
      fixedMediaHeight ? `height: 408px; grid-template-rows: 408px;` : `height: auto`}
  }
  ${breakpoints.desktop} {
    padding: ${spacing[10]}px 0;
    ${({ fixedMediaHeight }: { fixedMediaHeight: boolean }) =>
      fixedMediaHeight ? `height: 560px; grid-template-rows: 560px;` : `height: auto`}
  }
`;

const MobileOnly = styled.div`
  padding: ${spacing[8]}px ${spacing[4]}px;
`;

const MobileMedia = styled.div`
  margin-bottom: ${spacing[6]}px;
  ${({
    dynamicMediaHeight,
    fixedMediaHeight,
  }: {
    dynamicMediaHeight?: boolean;
    fixedMediaHeight?: boolean;
  }) =>
    dynamicMediaHeight
      ? `height: auto`
      : fixedMediaHeight
      ? 'height: 400px;'
      : `height: unset; max-height: 400px; margin-top: ${spacing[6]}px; margin-bottom: 0 `};
`;

type HighlightSectionLayoutProps = {
  media: ReactNode;
  content: ReactNode;
  reversed?: boolean;
  dynamicMediaHeight?: boolean;
  reversedMobile?: boolean;
  fixedMediaHeight?: boolean;
  className?: string;
};

const HighlightSectionLayout = ({
  content,
  media,
  reversed,
  reversedMobile,
  dynamicMediaHeight,
  fixedMediaHeight = true,
  className,
}: HighlightSectionLayoutProps) => {
  const [isTabletOrLarger] = useMediaQuery(breakpointQueries.tablet);
  return (
    <section className={className}>
      {isTabletOrLarger ? (
        <SizedRow fixedMediaHeight={fixedMediaHeight}>
          <Col tablet="span 6">{reversed ? media : content}</Col>
          <Col tablet="span 6">{reversed ? content : media}</Col>
        </SizedRow>
      ) : (
        <MobileOnly>
          {reversedMobile ? (
            <>
              {content}
              <MobileMedia
                dynamicMediaHeight={dynamicMediaHeight}
                fixedMediaHeight={fixedMediaHeight}
              >
                {media}
              </MobileMedia>
            </>
          ) : (
            <>
              <MobileMedia
                dynamicMediaHeight={dynamicMediaHeight}
                fixedMediaHeight={fixedMediaHeight}
              >
                {media}
              </MobileMedia>
              {content}
            </>
          )}
        </MobileOnly>
      )}
    </section>
  );
};

export default HighlightSectionLayout;
